<template>
  <b-form @submit.prevent="passwordReset">
    <h3 class="mb-4">Wachtwoord herstellen</h3>
    <b-input-group class="mb-3">
      <b-input-group-prepend>
        <b-input-group-text><i class="icon-user"></i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="email" class="form-control" placeholder="E-mail" v-model="form.email" required/>
    </b-input-group>
    <b-input-group class="mb-3">
      <b-input-group-prepend>
        <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="password" class="form-control" placeholder="Wachtwoord" v-model="form.password" required/>
    </b-input-group>
    <b-input-group class="mb-3">
      <b-input-group-prepend>
        <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="password" class="form-control" placeholder="Bevestig wachtwoord"
                    v-model="form.password_confirmation" required/>
    </b-input-group>
    <p v-if="message" class="text-danger">{{ message }}</p>
    <b-row>
      <b-col cols="12">
        <b-button variant="primary" class="px-4 mt-2" type="submit" :disabled="loading">
          Wachtwoord herstellen
          <b-spinner v-show="loading" small type="grow"/>
        </b-button>
      </b-col>
    </b-row>
  </b-form>

</template>

<script>
    import axios from 'axios';

    export default {
        name: 'password-reset',
        data() {
            return {
                form: {
                    email: null,
                    password: null,
                    password_confirmation: null,
                    token: this.$route.query.token,
                },
                message: null,
                success: false,
                loading: false,
            }
        },
        methods: {
            async passwordReset() {
                this.loading = true;
                const request = await axios.post(process.env.VUE_APP_API_URL + '/admin/auth/reset-password', this.form).catch(error => error.response);
                if (request.status !== 200) {
                    this.message = 'Er is iets misgegaan. Zeker dat alles klopt?';
                    this.loading = false;
                } else {
                    alert('Gelukt! We verwijzen je nu door naar de login pagina.');
                    this.$router.push('login');
                }
            }
        },
    }
</script>
